/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type AfterViewInit, Component, TemplateRef, ViewChild } from '@angular/core';
import { EventService, I18nService, PromptService } from '@dm/core';
import { SWITCH } from 'app/config';

@Component({
    selector: 'n-logout-tip',
    templateUrl: './logout-tip.component.html',
})
export class LogoutTipComponent implements AfterViewInit {
    @ViewChild(TemplateRef) template: TemplateRef<void>;

    private seconds = 5;
    tip: string;

    constructor(
        private i18nService: I18nService,
        private eventService: EventService,
        private promptService: PromptService,
    ) { }

    ngAfterViewInit(): void {
        this.promptService.prompt({
            title: this.i18nService.get('login_invalidSession_title'),
            content: this.template,
            onOk: () => this.doLogout(),
        });
        this.countdown();
    }

    countdown(): void {
        if (SWITCH.IS_VIRTUAL_MACHINE_CONSOLE) {
            this.tip = this.i18nService.get('system.vm_app_openConsole_shuttingDown_msg', [this.seconds]);
        } else {
            this.tip = this.i18nService.get('exitSystem_label', [this.seconds]);
        }

        if (this.seconds > 0) {
            setTimeout(() => {
                this.seconds--;
                this.countdown();
            }, 1000);
        } else {
            this.doLogout();
        }
    }

    private doLogout(): void {
        this.promptService.close();
        this.eventService.emit('logout');

        // 虚拟机页面超时后直接关闭页面
        if (SWITCH.IS_VIRTUAL_MACHINE_CONSOLE) {
            window.open('', '_parent', '');
            window.close();
        }
    }
}
